import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../../environments/environment';
import { ApiMethodService } from '../../../../tools/services/api/method-api/apiMethod.service';
import { ActionBackOfficeResponse } from '../../../models/api.model';
import {
  DeactivateEvPriceRatePayload,
  EvConnectorTypeOptionDto,
  EvPriceRateRowDto,
  EvPriceRateTableDto,
  EvPriceRateTableQuery,
  InsertEvPriceRatePayload,
  UpdateEvPriceRatePayload,
} from '../../../models/system-settings/ev-price-rate.model';

@Injectable({ providedIn: 'root' })
export class ApiEvPriceRateService {
  private readonly baseUrl = environment.apiPrivateUrl;
  private readonly cookieService = inject(CookieService);
  private readonly apiMethodService = inject(ApiMethodService);

  private get token(): string {
    return this.cookieService.get('token');
  }

  getEvPriceRatesForTable(query: EvPriceRateTableQuery): Observable<EvPriceRateTableDto> {
    const params: Record<string, string | number> = {
      page: query.page ?? 1,
      pageSize: query.pageSize ?? 20,
    };
    if (query.siteId) params['siteId'] = query.siteId;
    if (query.search) params['search'] = query.search;

    return this.apiMethodService.request<EvPriceRateTableDto>(
      '/SystemSettings/getEvPriceRatesForTable',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'getEvPriceRatesForTable',
        token: this.token,
        headerOnly: false,
        params,
      }
    );
  }

  getEvPriceRateById(id: number): Observable<EvPriceRateRowDto> {
    return this.apiMethodService.request<EvPriceRateRowDto>(
      '/SystemSettings/getEvPriceRateById',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'getEvPriceRateById',
        token: this.token,
        headerOnly: false,
        params: { id },
      }
    );
  }

  getEvConnectorTypes(activeOnly = true): Observable<EvConnectorTypeOptionDto[]> {
    return this.apiMethodService.request<EvConnectorTypeOptionDto[]>(
      '/SystemSettings/getEvConnectorTypes',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'getEvConnectorTypes',
        token: this.token,
        headerOnly: false,
        params: { activeOnly: activeOnly ? 'true' : 'false' },
      }
    );
  }

  insertEvPriceRate(payload: InsertEvPriceRatePayload): Observable<ActionBackOfficeResponse> {
    return this.apiMethodService.request<ActionBackOfficeResponse>(
      '/SystemSettings/insertEvPriceRate',
      'POST',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'insertEvPriceRate',
        token: this.token,
        headerOnly: false,
        body: payload,
      }
    );
  }

  updateEvPriceRate(payload: UpdateEvPriceRatePayload): Observable<ActionBackOfficeResponse> {
    return this.apiMethodService.request<ActionBackOfficeResponse>(
      '/SystemSettings/updateEvPriceRate',
      'POST',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'updateEvPriceRate',
        token: this.token,
        headerOnly: false,
        body: payload,
      }
    );
  }

  deactivateEvPriceRate(payload: DeactivateEvPriceRatePayload): Observable<ActionBackOfficeResponse> {
    return this.apiMethodService.request<ActionBackOfficeResponse>(
      '/SystemSettings/deactivateEvPriceRate',
      'POST',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'deactivateEvPriceRate',
        token: this.token,
        headerOnly: false,
        body: payload,
      }
    );
  }
}
